module.exports = __webpack_public_path__ + "img/americanexpress.5645420f.png";